<div class="full-width m-t-0-5" *ngIf="carrierVettingService.isMCPEnabled()">
	<mat-card class="p-0 primary-border">
		<mat-card-content class="">
			<ng-template [ngTemplateOutlet]="ccScore"></ng-template>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-16 font-weight-bold primary-text" fxLayoutAlign="start center">
					<span *ngIf="isCarrierInNetwork" fxLayoutAlign="start center">
						<img src="assets/icons/mcp_logo.png" class="mcp_image_container pr-8" />
						<span class="mcp_text">MyCarrierPortal </span>
					</span>
					<span *ngIf="!isCarrierInNetwork">C4</span>
					<span> &nbsp;Risk Assessment </span>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Overall</div>
				<div
					fxFlex
					class="font-size-14 {{ vettingOverallDisplay || '' }}"
					fxLayoutAlign="end center"
				>
					<span *ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader">
						{{ vettingOverallDisplay || 'N/A' }}
					</span>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Authority</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ vettingAuthorityDisplay || '' }}"
						fxLayoutAlign="end center"
					>
						<span *ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader">
							{{ vettingAuthorityDisplay || 'N/A' }}
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Insurance</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ vettingInsuranceDisplay || '' }}"
						fxLayoutAlign="end center"
					>
						<span *ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader">
							{{ vettingInsuranceDisplay || 'N/A' }}
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Operations</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ vettingOperationsDisplay || '' }}"
						fxLayoutAlign="end center"
					>
						<span *ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader">
							{{ vettingOperationsDisplay || 'N/A' }}
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Safety</div>
				<div
					fxFlex
					class="font-size-14 {{ mcpCarrierQuality?.safety || '' }}"
					fxLayoutAlign="end center"
				>
					<div
						fxFlex
						class="font-size-14 {{ vettingSafetyDisplay || '' }}"
						fxLayoutAlign="end center"
					>
						<span *ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader">
							{{ vettingSafetyDisplay || 'N/A' }}
						</span>
					</div>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</div>

<div class="full-width m-t-0-5" *ngIf="carrierVettingService.isRMISEnabled()">
	<mat-card class="p-0 primary-border">
		<mat-card-content class="">
			<ng-template [ngTemplateOutlet]="ccScore"></ng-template>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-16 font-weight-bold primary-text" fxLayoutAlign="start center">
					<img src="assets/icons/rmisImage.png" class="rmis_image_container" />
				</div>
				<div fxFlex class="font-size-16 font-weight-bold primary-text" fxLayoutAlign="end center">
					Risk Assessment
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Overall</div>
				<div fxFlex class="font-size-14 {{ getOverallDisplayClass() }}" fxLayoutAlign="end center">
					{{ vettingOverallDisplay || 'N/A' }}
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Authority</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ vettingAuthorityDisplay || '' }}"
						fxLayoutAlign="end center"
					>
						{{ vettingAuthorityDisplay || 'N/A' }}
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Insurance</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ vettingInsuranceDisplay || '' }}"
						fxLayoutAlign="end center"
					>
						{{ vettingInsuranceDisplay || 'N/A' }}
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Operations</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ vettingOperationsDisplay || '' }}"
						fxLayoutAlign="end center"
					>
						{{ vettingOperationsDisplay || 'N/A' }}
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Safety</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ vettingSafetyDisplay || '' }}"
						fxLayoutAlign="end center"
					>
						{{ vettingSafetyDisplay || 'N/A' }}
					</div>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</div>

<div
	class="full-width m-t-0-5"
	*ngIf="!carrierVettingService.isRMISEnabled() && !carrierVettingService.isMCPEnabled()"
>
	<mat-card class="p-0 primary-border">
		<mat-card-content class="">
			<ng-template [ngTemplateOutlet]="ccScore"></ng-template>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-16 font-weight-bold primary-text" fxLayoutAlign="start center">
					Risk Assessment
				</div>
				<div
					fxFlex
					class="font-size-16 font-weight-bold success-text"
					fxLayoutAlign="end center"
				></div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Overall</div>
				<div
					fxFlex
					class="font-size-14 {{ mcpCarrierQuality?.overall || '' }}"
					fxLayoutAlign="end center"
				>
					<span *ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader">
						{{ mcpCarrierQuality?.overall || 'N/A' }}
					</span>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Authority</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ mcpCarrierQuality?.authority || '' }}"
						fxLayoutAlign="end center"
					>
						<span *ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader">
							{{ mcpCarrierQuality?.authority || 'N/A' }}
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Insurance</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ mcpCarrierQuality?.insurance || '' }}"
						fxLayoutAlign="end center"
					>
						<span *ngIf="!isLoadingQualityScoreDetails; else skeletonLoader">
							<span *ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader">
								{{ mcpCarrierQuality?.insurance || 'N/A' }}
							</span>
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Operations</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ mcpCarrierQuality?.operations || '' }}"
						fxLayoutAlign="end center"
					>
						<span *ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader">
							{{ mcpCarrierQuality?.operations || 'N/A' }}
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Safety</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ mcpCarrierQuality?.safety || '' }}"
						fxLayoutAlign="end center"
					>
						<span *ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader">
							{{ mcpCarrierQuality?.safety || 'N/A' }}
						</span>
					</div>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</div>

<ng-template #skeletonLoader>
	<div fxFlex fxLayoutAlign="end center">
		<app-skeleton-loader
			[SHOW_SINGLE_LOADER]="true"
			class="skeletonLoaderWidth"
		></app-skeleton-loader>
	</div>
</ng-template>

<ng-template #ccScore>
	<div fxLayout="row" class="padding-0-5">
		<div fxFlex class="font-size-16 font-weight-bold primary-text" fxLayoutAlign="start center">
			Overall
		</div>
		<div
			fxFlex
			class="font-size-16 font-weight-bold {{ ccScoreDisplay }}"
			fxLayoutAlign="end center"
		>
			{{ ccScoreDisplay }}
		</div>
	</div>
	<div fxLayout="row" class="padding-0-5">
		<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Loads Booked</div>
		<div fxFlex class="font-size-14" fxLayoutAlign="end center">
			<div fxFlex class="font-size-14" fxLayoutAlign="end center">
				<span *ngIf="!isLoadingCarriersLoadsList; else skeletonLoader">
					{{ ccTotalBookedLoads || 'N/A' }}
				</span>
			</div>
		</div>
	</div>
	<div fxLayout="row" class="padding-0-5">
		<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Fall-Off Rate</div>
		<div fxFlex class="font-size-14" fxLayoutAlign="end center">
			<div fxFlex class="font-size-14" fxLayoutAlign="end center">
				<span *ngIf="!isLoadingQualityScoreDetails; else skeletonLoader">
					{{ ccFalloffRateDisplay || 'N/A' }}
				</span>
			</div>
		</div>
	</div>
	<div fxLayout="row" class="padding-0-5">
		<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Engagement Rate</div>
		<div fxFlex class="font-size-14" fxLayoutAlign="end center">
			<div fxFlex class="font-size-14" fxLayoutAlign="end center">
				<span *ngIf="!isLoadingQualityScoreDetails; else skeletonLoader">
					{{ ccEngagementRateDisplay || 'N/A' }}
				</span>
			</div>
		</div>
	</div>
	<div fxLayout="row" class="padding-0-5">
		<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Booking Rate</div>
		<div fxFlex class="font-size-14" fxLayoutAlign="end center">
			<div fxFlex class="font-size-14" fxLayoutAlign="end center">
				<span *ngIf="!isLoadingQualityScoreDetails; else skeletonLoader">
					{{ ccBookingRateDisplay || 'N/A' }}
				</span>
			</div>
		</div>
	</div>
</ng-template>
